<!--
 * @Descripttion: 
 * @version: 
 * @Author: lfs
 * @Date: 2022年11月04日 14:21:36
-->
<template>
  <div class="history-oec atb-flex atb-flex-column">
    <div class="search">
      <el-form :inline="true" :model="form" class="atb-input" ref="form">
        <el-form-item class="fflex-form-item" label="姓名">
          <selecter v-model="form.wkNo" clearable @selecterData="getSelecterData"></selecter>
        </el-form-item>
        <el-form-item class="flex-form-item" label="年份">
          <el-date-picker v-model="form.year" type="year" value-format="yyyy" placeholder="选择年" :clearable="false" :editable="false"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPersonData">查询</el-button>
        </el-form-item>
        <el-form-item label="">
            <el-checkbox v-model="form.isSub">直属下级</el-checkbox>
          </el-form-item>
      </el-form>
    </div>
    <div class="table-content atb-flex">
      <div class="left atb-flex atb-flex-column">
        <div class="left-table">
          <vxe-table
            stripe
            class="atb-table header-table edit-table"
            border="inner"
            height="100%"
            auto-resize
            highlight-hover-row
            highlight-current-row
            :data="personData"
            @current-change="currentChangeEvent"
            ref="person"
          >
            <vxe-table-column min-width="120" field="realityA" title="姓名">
              <template #default="{row}">
                <span>{{ `${row.wkName}(${row.wkNo})` }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="aFreq" min-width="30" title="A次数"></vxe-table-column>
            <vxe-table-column field="bFreq" min-width="30" title="B次数"></vxe-table-column>
            <vxe-table-column field="cFreq" min-width="30" title="C次数"></vxe-table-column>
          </vxe-table>
        </div>
      </div>
      <div class="right">
        <vxe-table
          stripe
          class="atb-table header-table edit-table"
          border="inner"
          height="100%"
          auto-resize
          highlight-hover-row
          :data="personDetail"
          @current-change="currentChangeEvent"
          ref="personDetail"
        >
          <vxe-table-column field="ratingResult" min-width="40" title="年月">
            <template #default="{row}">
              <span>{{ `${row.year}-${row.month}` }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingResult" min-width="40" title="历史评级"></vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div class="page-con atb-flex atb-flex-justify-end">
      <vxe-pager
        background
        :current-page.sync="page.PageIndex"
        :page-size.sync="page.PageSize"
        :total="total"
        height="100%"
        @page-change="handlePageChange"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
      >
      </vxe-pager>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  name: '',
  data() {
    return {
      personData: [],
      personDetail: [],
      form: {
        wkNo: '',
        year: new Date().getFullYear().toString(),
        isSub: true
      },
      seleterData: {},
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      total: 0,
    };
  },
  created() {
    this.getPersonData();
  },
  mounted() {},
  methods: {
    getSelecterData(data) {
      this.seleterData = data;
    },
    handlePageChange({ currentPage }) {
      this.page.PageIndex = currentPage;
      this.getPersonData();
    },
    getPersonData() {
      const param = Object.assign(
        {
          StartTime: this.form.year + '-01-01',
          EndTime: this.form.year + '-12-01',
          wkNo: this.form.wkNo,
          isSub: this.form.isSub
        },
        this.page
      );
      this.$ajax.get(this.$api.manage.declare.OecDeclareHistoryWindow, param).then((res) => {
        this.personData = res.data.rows;
        this.personDetail = this.personData.length && this.personData[0].detail;
        this.total = res.data.total;
        this.$nextTick(() => {
          this.$refs.person.setCurrentRow(this.personData[0]);
        });
      });
    },
    currentChangeEvent({ row }) {
      this.personDetail = row.detail;
    },
  },
};
</script>

<style scoped lang="scss">
.history-oec {
  height: 450px;
  ::v-deep .customerSelect{
    .el-input{
      width: 180px;
    }
  }
  ::v-deep .el-date-editor{
    width: 180px;
  }
  .table-content {
    .left {
      flex: 7;
      .left-table {
        flex: 1;
        overflow: auto;
      }
    }
    .right {
      flex: 3;
      margin-left: 20px;
    }
  }
}
</style>
